/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import {
  getDexWallet,
  createDexWallet,
  itemsSearch,
  itemsBreed,
  getWalletListOption,
} from "../../../services/app";
import { useNavigate } from "react-router-dom";
import { ITEM_TYPES, SORT_TYPE } from "../../../constants";
import { ItemEarnBig } from "../../../components/HomeGuide/ItemEarnBig";
import { ItemWeb3Kit } from "../../../components/HomeGuide/ItemWeb3Kit";
import { ItemReady } from "../../../components/HomeGuide/ItemReady";
import { ItemEarner } from "../../../components/HomeGuide/ItemEarner";
import * as Notification from "../../../Notification";
import { ModalMintNotify } from "../../../components/ModalMintNotify";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Scrollbar } from "swiper";
import "swiper/swiper-bundle.css";
import { ItemGrab } from "../../../components/HomeGuide/ItemGrab";
import { ItemAffiliate } from "../../../components/HomeGuide/ItemAffiliate";
import { ModalPolicy } from "../../../components/AffiliateComponent/ModalPolicy";
import useAffiliate from "../../../hook/useAffiliate";
import { PREPOSITION } from "..";
import useAgeRestriction from "../../../hook/useAgeRestriction";
import ModalAgeIneligible from "../../../components/ModalAgeIneligible";
import ModalUpdateAgeInformation from "../../../components/ModalUpdateAgeInformation";
import * as Sentry from "@sentry/react";

const MAX_ITEM_HOME = 4;
export const HomeGuide = () => {
  const { T, user, setAlert } = useApp();
  const navigate = useNavigate();
  const [isBtnLoading, $isBtnLoading] = useState(false);
  const [isShowCreateWeb3, setIsShowCreateWeb3] = useState(false);
  const [loadingContent, setLoadingContent] = useState(false);
  const [isShowCreateWeb3ToClaim, setIsShowCreateWeb3ToClaim] = useState(false);
  const [isShowCreateWeb3Success, setIsShowCreateWeb3Success] = useState(false);
  const paramsSearch = {
    itemTypes: [],
    page: 1,
    size: MAX_ITEM_HOME,
    sort: SORT_TYPE.CREATED_TIME,
  };
  const [itemsCategories, setItemsCategories] = useState([]);
  const [dataGuild, setDataGuild] = useState({
    address: null,
    earners: [],
    minted: [],
  });
  const {
    onAffiliate,
    onConfirmPolicy,
    isOpenModalPolicy,
    setIsOpenModalPolicy,
    isAgreeing,
  } = useAffiliate();

  const [isShowModalUpdateAgeInformation, setIsShowModalUpdateAgeInformation] =
    useState(false);
  const [isShowModalAgeIneligible, setIsShowModalAgeIneligible] =
    useState(false);
  const affiliateWindowRef = useRef(null);

  const closeAffiliateWindow = () => {
    if (affiliateWindowRef.current && !affiliateWindowRef.current.closed) {
      affiliateWindowRef.current.close();
    }
    affiliateWindowRef.current = null;
  };

  const openAffiliateWindow = () => {
    closeAffiliateWindow();
    const targetWindow = window.open("about:blank", "_blank");
    affiliateWindowRef.current = targetWindow;
    return targetWindow;
  };

  const handleAffiliateClick = () => {
    try {
      const shouldOpenWindow = Number(user?.is_agree_policy) !== 0;
      const targetWindow = shouldOpenWindow ? openAffiliateWindow() : null;
      checkAge(() => onAffiliate({ targetWindow }));
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          function: "handleAffiliateClick",
        },
        extra: {
          userId: user?.id,
          mlmId: user?.mlm_id,
          isAgreePolicy: user?.is_agree_policy,
        },
      });
      throw error;
    }
  };
  
  const handleBuzznetAffiliateClick = () => {
    const buzznetUrl = process.env.REACT_APP_BUZZNET_URL ?? "https://buzznet.aiavatar.fun";
    const url = `${buzznetUrl}?ref=ams&referral_id=${user?.id}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const { checkAge } = useAgeRestriction({
    onRequireUpdate: () => {
      setIsShowModalUpdateAgeInformation(true);
      setIsShowModalAgeIneligible(false);
      closeAffiliateWindow();
    },
    onEligible: () => {
      setIsShowModalUpdateAgeInformation(false);
      setIsShowModalAgeIneligible(false);
    },
    onIneligible: () => {
      setIsShowModalUpdateAgeInformation(false);
      setIsShowModalAgeIneligible(true);
      closeAffiliateWindow();
    },
    onError: (error) => {
      closeAffiliateWindow();
      setAlert({
        type: "error",
        text: T("Something went wrong! Please try again later!"),
      });
    },
  });

  const loadData = async () => {
    setLoadingContent(true);
    const promises = [];
    promises.push(
      itemsSearch({ ...paramsSearch, itemTypes: [ITEM_TYPES.ITEM_TYPE_DOG] }),
    );
    promises.push(
      itemsSearch({
        ...paramsSearch,
        itemTypes: [ITEM_TYPES.ITEM_TYPE_DOG],
        isNFT: true,
      }),
    );
    promises.push(getDexWallet());
    promises.push(itemsBreed(9));

    Promise.all(promises)
      .then((result) => {
        const dataEarners = result[0].data?.data?.items?.rows || [];
        const dataMinted = result[1].data?.data?.items?.rows || [];
        const dataWallet = result[2]?.data?.data?.public_address || null;
        const dataCategories = result[3]?.data?.data?.categories || [];
        setDataGuild({
          minted: dataMinted,
          address: dataWallet,
          earners: dataEarners,
        });
        setItemsCategories(dataCategories);
      })
      .finally(() => {
        setLoadingContent(false);
      });
  };

  const handleExploreEarner = () => {
    navigate(`/asset?type=${PREPOSITION.EARNER}`);
  };

  const claimSot = async () => {
    try {
      const resultDexWallet = await getDexWallet();
      if (resultDexWallet?.data?.data?.public_address) {
        navigate(`/wallet?type=option`);
      } else {
        setIsShowCreateWeb3ToClaim(true);
      }
    } catch (e) {
      setIsShowCreateWeb3ToClaim(true);
    }
  };
  useEffect(() => {
    loadData();
  }, []);

  const handelCreateWeb3Address = async (type) => {
    try {
      if (isBtnLoading) return;
      $isBtnLoading(true);
      const createResult = await createDexWallet();
      if (createResult?.data?.error?.status) {
        loadData();
        if (type === 1) {
          setIsShowCreateWeb3(true);
        } else {
          setIsShowCreateWeb3Success(true);
          setIsShowCreateWeb3ToClaim(false);
        }
      } else {
        Notification.error(T(createResult?.data?.error?.message));
      }
    } catch (e) {
      console.error("err create wallet: ", e);
      Notification.error(T("Create web3 wallet unsuccessfully"));
    }
    $isBtnLoading(false);
  };

  const [isShowAccessSOT, setIsShowAccessSOT] = useState(false);
  useEffect(() => {
    loadSOTBalance();
  }, []);
  const loadSOTBalance = async () => {
    try {
      const result = await getWalletListOption();
      if (
        Array.isArray(result?.data?.data) &&
        (result?.data?.data.length ?? 0) > 0
      ) {
        setIsShowAccessSOT(true);
      } else {
        setIsShowAccessSOT(false);
      }
    } catch (error) {
      setIsShowAccessSOT(false);
      console.error("err get sot balance: ", error);
    }
  };

  return (
    // <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px] lg:gap-[30px] mt-[30px] lg:mt-[50px]">
    loadingContent ? (
      <></>
    ) : (
      <div className="mt-[20px] lg:mt-[30px] relative">
        <Swiper
          slidesPerView={1}
          centeredSlides={false}
          breakpoints={{
            769: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
          }}
          lazyPreloadPrevNext={2}
          grabCursor={true}
          scrollbar={{ draggable: true }}
          spaceBetween={20}
          navigation={{ nextEl: ".arrow-right", prevEl: ".arrow-left" }}
          modules={[Navigation, Scrollbar]}
          className="mySwiper"
        >
          {user.mlm_id && (
            <SwiperSlide key={1}>
              <div className="w-full overflow-hidden">
                <ItemAffiliate
                  title={T("Welcome to affiliate")}
                  description={T(
                    "Explore your dashboard, track your activities, and discover new ways to share AI Avatar with the world.",
                  )}
                  className="my-affiliate-bg"
                  btnActionTitle={T("My Affiliate")}
                  btnAction={handleAffiliateClick}
                />
              </div>
            </SwiperSlide>
          )}
          {!user.mlm_id && (
            <SwiperSlide key={2}>
              <div className="w-full overflow-hidden">
                <ItemAffiliate
                  title={T("Discover a creative community")}
                  description={T(
                    "Join the community, invite friends, and share the experience together.",
                  )}
                  className="join-affiliate-bg"
                  btnActionTitle={T("Join now")}
                  btnAction={handleAffiliateClick}
                />
              </div>
            </SwiperSlide>
          )}
          <SwiperSlide key={3}>
            <div className="w-full overflow-hidden">
              <ItemAffiliate
                title={T("Grow & Earn with Buzznet")}
                description={T("Share supported content to earn your first results, create posts to build your personal brand.")}
                className="buzznet-affiliate-bg"
                btnActionTitle={T("Log in")}
                btnAction={handleBuzznetAffiliateClick}
              />
            </div>
          </SwiperSlide>
          {!dataGuild?.address && dataGuild?.earners?.length === 0 && (
            <>
              <SwiperSlide key={4}>
                <div className="w-full overflow-hidden">
                  <ItemEarnBig
                    title={"RISING with AI AVATAR arts"}
                    description={
                      "Collect unique creations, unlock experiences, and trade in global marketplaces."
                    }
                    className="earn-big-bg"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide key={5}>
                <div className="w-full overflow-hidden">
                  <ItemWeb3Kit
                    title={"item_web3_title"}
                    description={
                      "Unlock seamless trading, storing, and managing with AI Avatar Web3 Wallet. Secure your crypto and NFTs with 24/7 access."
                    }
                    className="web-3-bg"
                    handleAction={() => handelCreateWeb3Address(1)}
                    isLoading={isBtnLoading}
                  />
                </div>
              </SwiperSlide>
            </>
          )}
          {!dataGuild?.address &&
            dataGuild?.earners?.length > 0 &&
            dataGuild?.minted?.length === 0 && (
              <>
                <SwiperSlide key={6}>
                  <div className="w-full overflow-hidden">
                    <ItemReady
                      title={"item_ready_title"}
                      description={
                        "Ensure you have an active AI Avatar Web3 account. Your minted NFT will be securely stored in our Web3 Wallet and can be easily traded on any NFT marketplace."
                      }
                      className="ready-turner-bg"
                      isShowBtn={true}
                      actionBtn={handleExploreEarner}
                      actionBtnRight={() => handelCreateWeb3Address(1)}
                      isLoading={isBtnLoading}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide key={7}>
                  <div className="w-full overflow-hidden">
                    <ItemEarner
                      title={"Your recent purchased Avatar"}
                      itemData={dataGuild?.earners?.[0]}
                      categories={itemsCategories}
                      type={1}
                    />
                  </div>
                </SwiperSlide>
                {isShowAccessSOT && (
                  <SwiperSlide key={8}>
                    <div className="w-full overflow-hidden">
                      <ItemGrab
                        title={"Access your SOTs"}
                        description={
                          "Redeem and swap for new digital experiences."
                        }
                        className="grab-bg"
                        btnAction={claimSot}
                      />
                    </div>
                  </SwiperSlide>
                )}
              </>
            )}
          {dataGuild?.address && dataGuild?.earners?.length === 0 && (
            <>
              <SwiperSlide key={9}>
                <div className="w-full overflow-hidden">
                  <ItemEarnBig
                    title={"RISING with AI AVATAR arts"}
                    description={
                      "Collect unique creations, unlock experiences, and trade in global marketplaces."
                    }
                    className="earn-big-bg"
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide key={10}>
                <div className="w-full overflow-hidden">
                  <ItemReady
                    title={"item_ready_title"}
                    description={
                      "Ensure you have an active AI Avatar Web3 account. Your minted NFT will be securely stored in our Web3 Wallet and can be easily traded on any NFT marketplace."
                    }
                    className="ready-turner-bg"
                    isShowBtn={false}
                    actionBtn={handleExploreEarner}
                  />
                </div>
              </SwiperSlide>
              {isShowAccessSOT && (
                <SwiperSlide key={11}>
                  <div className="w-full overflow-hidden">
                    <ItemGrab
                      title={"Access your SOTs"}
                      description={
                        "Redeem and swap for new digital experiences."
                      }
                      className="grab-bg"
                      btnAction={claimSot}
                    />
                  </div>
                </SwiperSlide>
              )}
            </>
          )}
          {dataGuild?.address &&
            dataGuild?.earners?.length > 0 &&
            dataGuild?.minted?.length === 0 && (
              <>
                <SwiperSlide key={12}>
                  <div className="w-full overflow-hidden">
                    <ItemReady
                      title={"item_ready_title"}
                      description={
                        "Ensure you have an active AI Avatar Web3 account. Your minted NFT will be securely stored in our Web3 Wallet and can be easily traded on any NFT marketplace."
                      }
                      className="ready-turner-bg"
                      isShowBtn={false}
                      actionBtn={handleExploreEarner}
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide key={13}>
                  <div className="w-full overflow-hidden">
                    <ItemEarner
                      title={"Your recent purchased Avatar"}
                      itemData={dataGuild?.earners?.[0]}
                      categories={itemsCategories}
                      type={1}
                    />
                  </div>
                </SwiperSlide>
                {isShowAccessSOT && (
                  <SwiperSlide key={14}>
                    <div className="w-full overflow-hidden">
                      <ItemGrab
                        title={"Access your SOTs"}
                        description={
                          "Redeem and swap for new digital experiences."
                        }
                        className="grab-bg"
                        btnAction={claimSot}
                      />
                    </div>
                  </SwiperSlide>
                )}
              </>
            )}
          {dataGuild?.address &&
            dataGuild?.earners?.length > 0 &&
            dataGuild?.minted?.length > 0 && (
              <>
                <SwiperSlide key={16}>
                  <div className="w-full overflow-hidden">
                    <div className="w-full overflow-hidden">
                      <ItemEarner
                        title={"Your recent minted NFT"}
                        itemData={dataGuild?.minted?.[0]}
                        categories={itemsCategories}
                        type={2}
                      />
                    </div>
                  </div>
                </SwiperSlide>
                {isShowAccessSOT && (
                  <SwiperSlide key={17}>
                    <div className="w-full overflow-hidden">
                      <ItemGrab
                        title={"Access your SOTs"}
                        description={
                          "Redeem and swap for new digital experiences."
                        }
                        className="grab-bg"
                        btnAction={claimSot}
                      />
                    </div>
                  </SwiperSlide>
                )}
              </>
            )}
        </Swiper>
        <button className="arrow-left swiper-button-prev"></button>
        <button className="arrow-right swiper-button-next"></button>
        {isShowCreateWeb3 && (
          <ModalMintNotify
            onClose={() => setIsShowCreateWeb3(false)}
            onSubmit={() => setIsShowCreateWeb3(false)}
            isLoading={isBtnLoading}
            title={T("Created Web3 Wallet successfully")}
            des={
              "Your web3 wallet has been created successfully. Please access your Web3 Wallet on AI Avatar app. Now you can trade, store and manage your crypto and NFTs with AI Avatar Web3 Wallet."
            }
            buttonText={T("OK")}
          />
        )}
        {isShowCreateWeb3ToClaim && (
          <ModalMintNotify
            onClose={() => setIsShowCreateWeb3ToClaim(false)}
            onSubmit={() => handelCreateWeb3Address(2)}
            isLoading={isBtnLoading}
            title={T("AI Avatar Web3 Wallet not created!")}
            des={T(
              "You have not created AI Avatar Web3 Wallet to grab SOT1. Please create a AI Avatar Wallet and try again!",
            )}
            buttonText={T("Create Web3 Wallet")}
          />
        )}
        {isShowCreateWeb3Success && (
          <ModalMintNotify
            onClose={() => setIsShowCreateWeb3Success(false)}
            onSubmit={() => claimSot()}
            title={T("Created Web3 Wallet successfully!")}
            des={T(
              "Your web3 wallet has been created successfully. Please access your web3 wallet on AI Avatar app. Now you can convert SOT to SGT using AI Avatar Web3 wallet.",
            )}
            buttonText={T("Continue to claim")}
          />
        )}

        {isOpenModalPolicy && (
          <ModalPolicy
            onClose={() => setIsOpenModalPolicy(false)}
            handleSubmit={() => onConfirmPolicy()}
            disable={isAgreeing}
          ></ModalPolicy>
        )}

        {isShowModalAgeIneligible && (
          <ModalAgeIneligible
            title={T("Affiliate Program Restriction")}
            message={T("Age Requirement Not Met")}
            description={T(
              "You're not eligible to join the affiliate program due to age requirements.",
            )}
            onClose={() => setIsShowModalAgeIneligible(false)}
            onConfirm={() => {
              setIsShowModalAgeIneligible(false);
            }}
          ></ModalAgeIneligible>
        )}
        {isShowModalUpdateAgeInformation && (
          <ModalUpdateAgeInformation
            title={T("Affiliate Program Restriction")}
            message={T("Age Information not found")}
            description={T(
              "Please provide the age information before taking further action.",
            )}
            onClose={() => setIsShowModalUpdateAgeInformation(false)}
            onConfirm={() => {
              setIsShowModalUpdateAgeInformation(false);
              navigate("/profile");
            }}
          ></ModalUpdateAgeInformation>
        )}
      </div>
    )
  );
};
